import React, { useState, useEffect } from 'react'
import { Navigate } from 'react-router-dom'
import BupLoading from '@BUP/components/Loading/Main'
import { useAuthUser } from '@BUP/services/auth/use-auth-user.jsx'

const PrivateRoute = ({ children }) => {
  const [isLoading, setIsLoading] = useState(true)
  const authUser = useAuthUser()
  useEffect(() => {
    setTimeout(() => setIsLoading(false), 1000)
  }, [])

  if (isLoading) return <BupLoading />

  return authUser ? children : <Navigate to='/login' />
}

export default PrivateRoute
